import { NUANCE_CONFIG, NUANCE_TIMEOUT } from "../constants";

type NuanceData = {
  browseCountry: string;
  browseLanguage: string;
  customerId: string;
  isAuthenticated: boolean;
  referrer: string;
  storeCode: string;
  shop: string;
  accessToken: string;
  firstName?: string;
  lastName?: string;
};

export const initialise = async (
  nuanceData: NuanceData,
  onStatusChange: (state: string) => void,
): Promise<boolean> => {
  let timeout: NodeJS.Timeout | undefined;

  try {
    return await new Promise((resolve, reject) => {
      timeout = setTimeout(() => {
        reject(new Error("Nuance Timeout"));
      }, NUANCE_TIMEOUT);

      const c2c = new BootStrapC2C({
        accessibilityMessages: {
          end: "End Chat",
          resume: "Resume Chat",
          start: "Start Chat",
        },
      });

      NuanMessaging.initializeMessagingSDK(
        NUANCE_CONFIG.dataCenter,
        NUANCE_CONFIG.tagServerName,
        NUANCE_CONFIG.vendorUUID,
        () => {
          NuanMessaging.getAndSetSDKConfig().siteID = NUANCE_CONFIG.vendorUUID;

          NuanMessaging.getAndSetSDKConfig().registerForMessagingEvents(
            "onC2CStateChanged",
            (event: { newState: string }) => {
              const { newState } = event;

              clearTimeout(timeout);
              onStatusChange(newState);
              resolve(true);
            },
          );

          NuanMessaging.getAndSetSDKConfig().enableC2CPluginForMinimizedState(
            c2c,
          );
          NuanMessaging.getAndSetSDKConfig().isEmbedded = true;
          NuanMessaging.getAndSetSDKConfig().setPageData(
            "bootstrap1PCSolution",
            true,
          );
          NuanMessaging.getAndSetSDKConfig().setPageData(
            "nuanceData",
            nuanceData,
          );
          NuanMessaging.loadChatAssets(true);
        },
      );
    });
  } finally {
    clearTimeout(timeout);
  }
};
